import React, { useEffect, useRef } from 'react';

/**
 * 星星爆发奖励效果
 * 触发时：播放 victory.mp3 + 屏幕星星扩散动画
 */
const SOUND_URL = '/media/sounds/victory.mp3';

export default function RewardEffect({ trigger, onDone }) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!trigger) return;

    // 播放音效
    if (!audioRef.current) {
      audioRef.current = new Audio(SOUND_URL);
    }
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(() => {});

    // 动画结束后回调
    const timer = setTimeout(() => {
      onDone?.();
    }, 1200);

    return () => clearTimeout(timer);
  }, [trigger, onDone]);

  if (!trigger) return null;

  return (
    <div className="reward-overlay">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className={`reward-star reward-star-${i}`}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l2.4 7.4H22l-6 4.6 2.3 7L12 17l-6.3 4 2.3-7L2 9.4h7.6z" />
          </svg>
        </div>
      ))}
    </div>
  );
}
